import $ from 'jquery'

$(document).ready(dhsv_vc_color_boxes())

function dhsv_vc_color_boxes() {}
